import { Label } from "../../labels/englishLabels";
import { QueryParams } from "../../models/navigation/navigationParams.interface";
import { EnterpriseAiFindingComponent } from "../../views/enterprise-ai/enterprise-ai-finding/enterprise-ai-finding.component";
import { AgentStepComponent } from "../../views/enterprise-ai/enterprise-ai-agent-step/enterprise-ai-agent-step.component";
import { SidePanel, SidePanelRouteState, SidePanelTree } from "./types/side-panel";
import { InventoryResourceComponent } from "../../views/inventory-resource/inventory-resource.component";
import { PreventionDetailsComponent } from "../../views/enterprise-ai/enterprise-ai-prevention-details/enterprise-ai-prevention-details.component";
import { IssueComponent } from "../../views/issue/issue.component";
import { ViolationComponent } from "../../views/violation/violation.component";
import { AiPreventionMockTableRowViewModel } from "src/app/models/viewModels/aiPreventionMockTableRowViewModel";

const violationKeyboardShortcuts = Label.get("keyboardShortcuts.violations");
const agentStepKeyboardShortcuts = Label.get("keyboardShortcuts.agentSteps");
const findingsKeyboardShortcuts = Label.get("keyboardShortcuts.findings");
const resourcesKeyboardShortcuts = Label.get("keyboardShortcuts.resources");
const preventionKeyboardShortcuts = Label.get("keyboardShortcuts.prevention");
const issueKeyboardShortcuts = Label.get("keyboardShortcuts.issues");

export const getConfig = (): SidePanelTree[] => [
    {
        param: QueryParams.integration,
        nested: {
            param: QueryParams.finding,
            config: {
                component: EnterpriseAiFindingComponent,
                inputs: ({ finding, integration }: SidePanelRouteState, viewModel) => ({
                    integration,
                    finding,
                    viewModel,
                }),
                shortcuts: findingsKeyboardShortcuts,
            } as SidePanel<EnterpriseAiFindingComponent>,
            nested: {
                param: QueryParams.stepThreadId,
                nested: {
                    param: QueryParams.agentStep,
                    config: {
                        component: AgentStepComponent,
                        inputs: ({ agentStep, integration, stepThreadId }, viewModel) => ({
                            integration,
                            agentStep,
                            stepThreadId: stepThreadId ?? "",
                            viewModel,
                        }),
                    } as SidePanel<AgentStepComponent>,
                    nested: null,
                },
            },
        },
    },
    {
        param: QueryParams.agentStep,
        nested: {
            param: QueryParams.integration,
            nested: {
                param: QueryParams.stepThreadId,
                nested: null,
                config: {
                    component: AgentStepComponent,
                    inputs: ({ agentStep, integration, stepThreadId }, viewModel) => ({
                        integration,
                        agentStep,
                        stepThreadId: stepThreadId ?? "",
                        viewModel,
                    }),
                    shortcuts: agentStepKeyboardShortcuts,
                } as SidePanel<AgentStepComponent>,
            },
        },
    },
    {
        param: QueryParams.resource,
        nested: {
            param: QueryParams.integration,
            nested: null,
            config: {
                component: InventoryResourceComponent,
                inputs: ({ integration, resource }, viewModel) => ({
                    integration,
                    resource,
                    viewModel,
                }),
                shortcuts: resourcesKeyboardShortcuts,
            } as SidePanel<InventoryResourceComponent>,
        },
    },
    {
        param: QueryParams.prevention,
        nested: {
            param: QueryParams.integration,
            nested: null,
            config: {
                component: PreventionDetailsComponent,
                inputs: ({ preventionId }, viewModel) => ({
                    prevention: (viewModel as AiPreventionMockTableRowViewModel)?.prevention ?? preventionId,
                }),
                shortcuts: preventionKeyboardShortcuts,
            } as SidePanel<PreventionDetailsComponent>,
        },
    },
    {
        param: QueryParams.issue,
        nested: {
            param: QueryParams.integration,
            nested: null,
            config: {
                component: IssueComponent,
                inputs: ({ issue, integration }, viewModel) => ({
                    issue,
                    integration,
                    viewModel,
                }),
                shortcuts: issueKeyboardShortcuts,
            } as SidePanel<IssueComponent>,
        },
    },
    {
        param: QueryParams.violation,
        nested: {
            param: QueryParams.integration,
            nested: null,
            config: {
                component: ViolationComponent,
                inputs: ({ violation, integration }) => ({
                    violation,
                    integration,
                }),
                shortcuts: violationKeyboardShortcuts,
            } as SidePanel<ViolationComponent>,
        },
    },
];
